import { createContext } from 'react';
import type { LegalRepresentativesManagementType } from './types';

const LegalRepresentativesManagement =
  createContext<LegalRepresentativesManagementType>(
    {} as LegalRepresentativesManagementType,
  );

export default LegalRepresentativesManagement;
